// extracted by mini-css-extract-plugin
export default {"content":"styles_content__e1jxd","list":"styles_list__mwmcD"};